"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entityRequest_1 = require("../entityRequest");
const users = (creds, Ienvironment, fetchExecutor) => ({
    addFavorite: (id, type, userId) => {
        const body = type === "Community" ? { community_id: id } : { mobilehome_id: id };
        return (0, entityRequest_1.requestPost)(`v1/users/${userId}/favorites`, creds, "Favorites", Ienvironment, fetchExecutor, body);
    },
    deleteFavorite: (id, userId) => {
        return (0, entityRequest_1.requestDelete)(`v1/users/${userId}/favorites/${id}`, creds, Ienvironment, fetchExecutor);
    },
    getFavorites: (userId) => {
        return (0, entityRequest_1.requestGet)(`v1/users/${userId}/favorites`, creds, "Favorites", Ienvironment, fetchExecutor);
    },
});
exports.default = users;
